import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { TranslateModule } from '@ngx-translate/core';

import { AnalyticsModule } from 'rev-shared/analytics/Analytics.Module';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DataGridModule } from 'rev-shared/ui/dataGrid/DataGrid.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SearchInputModule } from 'rev-shared/ui/searchInputAngular/SearchInput.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';

import { WebcastAttendeesListComponent } from './WebcastAttendeesList.Component';
import { WebcastAttendeeRendererComponent } from './WebcastAttendeeRenderer.Component';

const components = [
	WebcastAttendeesListComponent,
	WebcastAttendeeRendererComponent
];

@NgModule({
	declarations: components,
	exports: [
		WebcastAttendeesListComponent
	],
	imports: [
		AnalyticsModule,
		BrandingAngularModule,
		ButtonsAngularModule,
		CommonModule,
		DataGridModule,
		DialogAngularModule,
		FormsModule,
		PipesAngularModule,
		PushModule,
		SearchInputModule,
		TranslateModule,
		UIRouterModule,
		VbProfilePictureModule
	]
})
export class WebcastAttendeesModule {
}
